<template>
    <div class="col-xl-4 col-lg-4 col-md-6 col-sm-12 mb-5 zoom">
        <div class="_plan b-white  shadow-lg">
            <div class="_header b-blue py-5 text-center align-items-center">
                <h3 class="font-weight-bold m-0">PLATA</h3>
                <small>Conviértete en miembro Plata</small>
            </div>
            <div>
                <div class="py-3 font-weight-bold text-center  mt-3">Elige tiempo a contratar</div>
                <div class="px-5 py-3">
                    <b-form-select
                            class="plan-selector shadow "
                            v-model="selected"
                            :options="options"
                            @change="changeMember">
                    </b-form-select>
                </div>

<!--                <ul class="list-unstyled mt-3 text-left">-->
<!--                    <li>Además de los beneficios de la membresía gratuita; incluye:</li>-->
<!--                    <br>-->
<!--                    <li>-->
<!--                        <i class="fas fa-check font-green"></i>-->
<!--                        Filtros avanzados <span>*</span>-->
<!--                    </li>-->
<!--                    <li>-->
<!--                        <i class="fas fa-check font-green"></i>-->
<!--                        Contacta hasta {{ membershipSelection.candidates }} candidatos-->
<!--                    </li>-->
<!--                    <li style="margin-left: 20px">-->
<!--                        <small>No acumulables</small>-->
<!--                    </li>-->
<!--                    <li style="margin-left: 20px">-->
<!--                        <small>Vigencia:-->
<!--                            {{ meses(membershipSelection.validity) }}-->
<!--                        </small>-->
<!--                    </li>-->
<!--                    <li>-->
<!--                        <i class="fas fa-check font-green"></i>-->
<!--                        Comparte flyer virtual <span>**</span>-->
<!--                    </li>-->
<!--                    <ul class="__social list-inline" style="margin-left: 20px">-->
<!--                        <li class="list-inline-item font-size-15">-->
<!--                            <i class="fab fa-whatsapp"></i>-->
<!--                        </li>-->
<!--                        <li class="list-inline-item font-size-15">-->
<!--                            <i class="fab fa-facebook-f"></i>-->
<!--                        </li>-->
<!--                        <li class="list-inline-item font-size-15">-->
<!--                            <i class="fas fa-envelope"></i>-->
<!--                        </li>-->
<!--                        <li class="list-inline-item font-size-15">-->
<!--                            <i class="fab fa-twitter"></i>-->
<!--                        </li>-->
<!--                    </ul>-->
<!--                </ul>-->
                <div class="_ font-blue px-2 py-2 mt-3"><h6>Además de los beneficios de la membresía gratuita; incluye:</h6></div>
				<ul class="list-unstyled mt-3  text-left  font-blue"  style="background: #edf9ff;">
					<li class="px-3 py-2" style="list-style-type: none;"><i class="fas fa-circle font-yellow"></i> Llena tu perfil</li>
					<li class="px-3 py-2" style="list-style-type: none;"><i class="fas fa-circle font-yellow"></i> Accede a sección de candidatos</li>
					<li class="px-3 py-2" style="list-style-type: none;"><i class="fas fa-circle font-yellow"></i> Ve tu perfil básico</li>
					<li class="px-3 py-2" style="list-style-type: none;"><i class="fas fa-circle font-yellow"></i> Conoce tu reputación</li>
					<li class="px-3 py-2" style="list-style-type: none;"><i class="fas fa-circle font-yellow"></i> Búsqueda por palabras clave</li>
					<li class="px-3 py-2" style="list-style-type: none;"><i class="fas fa-circle font-yellow"></i> Subir vacantes sin acceso a filtros de <span>restricción</span></li> 

					<li class="px-3 py-2" style="list-style-type: none;">
						<i class="fas fa-circle font-yellow"></i>
						Filtros avanzados <span>*</span>
					</li>
					<li class="px-3 py-2" style="list-style-type: none;">
						<i class="fas fa-circle font-yellow"></i>
						Contacta hasta {{ membershipSelection.candidates }} candidatos
					</li>
					<li class="px-3 py-2" style="margin-left: 20px; list-style-type: none;">
						<small>No acumulables</small>
					</li>
					<li class="px-3 py-2" style="margin-left: 20px; list-style-type: none;">
						<small>Vigencia:
							{{ meses(membershipSelection.validity) }}
						</small>
					</li>
					<li class="px-3 py-2" style="list-style-type: none;">
						<i class="fas fa-circle font-yellow"></i>
						Comparte flyer virtual <span>**</span>
					</li>
					<ul class="__social list-inline px-3 py-2" style="margin-left: 20px;">
						<li class="list-inline-item font-size-15" style="list-style-type: none;">
							<i class="fab fa-whatsapp"></i>
						</li>
						<li class="list-inline-item font-size-15" style="list-style-type: none;">
							<i class="fab fa-facebook-f"></i>
						</li>
						<li class="list-inline-item font-size-15" style="list-style-type: none;">
							<i class="fas fa-envelope"></i>
						</li>
						<li class="list-inline-item font-size-15" style="list-style-type: none;">
							<i class="fab fa-twitter"></i>
						</li>
					</ul>
				</ul>
				<ul class="list-unstyled mt-3 text-left font-gray-dark">
					<li style="list-style-type: none;">
						<b><i class="fas fa-check text-white"></i> Accede a perfil completo</b>
					</li>
					<li style="margin-left: 20px; list-style-type: none;">
						<small>
							Competencias y Habilidades
						</small>
					</li>
					<li style="list-style-type: none;">
						<b><i class="fas fa-check text-white"></i> Kllaar Match</b>
					</li>
					<li style="margin-left: 20px; list-style-type: none;">
						<small>
							Te mostraremos a los candidatos con mayor compatibilidad en <b>Tiempo Real</b>
						</small>
					</li>
				</ul>
                <div class="__percentage text-white py-3 m-0 rounded" style="background: #2ECC71"
                     v-if="membershipSelection.percentage.one ||membershipSelection.percentage.two ">

                    <p class="h4 p-0 m-0" v-if="membershipSelection.percentage.one > 0">
                        <b class="h4">+{{ membershipSelection.percentage.one }}</b>
                        {{ (membershipSelection.percentage.one === 1) ? ' mes' : 'meses' }}
                        con
                        <b class="h4">50%</b> de desc.
                    </p>
                    <p class="h4 p-0 m-0" v-if="membershipSelection.percentage.two > 0">
                        <b class="h4">+{{ membershipSelection.percentage.two }}</b>
                        {{ (membershipSelection.percentage.two === 1) ? ' mes' : 'meses' }}
                        gratis
                    </p>
                    <p class="p-0 m-0">
                        <b>Vigencia
                            {{ meses(membershipSelection.validity) }}</b>
                    </p>
                </div>
                <div class="__price text-center py-1 mt-4 border-top border-bottom font-blue">
                    <h1>
                        <h2 class="fas fa-dollar-sign"></h2>
                        {{ membershipSelection.price }} MXN
                    </h1>
                </div>
                <div class="_action py-3 px-5 text-center">
                    <button class="btn btn-block p-3 b-blue" @click="sendPayment">¡Lo quiero!</button>
                </div>
            </div>
        </div>
        <div class="py-4 px-2">
            <small>
                * Filtros avanzados para una búsqueda más precisa <br>
                ** Comparte el perfil de tu empresa
            </small>
        </div>
    </div>
</template>
<style scoped>
.zoom {
    transition: transform .5s ease;
}
.zoom:hover {
    z-index: 2;
    transform: scale(1.1);
}

._plan {
    border-radius: 30px 30px 30px 30px;
    -webkit-box-shadow: 0px 6px 31px -8px rgba(48, 101, 207, 0.38);
    -moz-box-shadow: 0px 6px 31px -8px rgba(48, 101, 207, 0.38);
    box-shadow: 0px 6px 31px -8px rgba(48, 101, 207, 0.38);
    min-height: 652px;
}

._plan ._header {
    border-radius: 30px 30px 0 0;
}

._plan .plan-selector {
    border-left: 3px solid #244076 !important;
    color: #244076;
    cursor: pointer;
}

._plan .custom-select {
    font-size: 20px;
    border: 0;
    border-bottom: 1px solid #EEE;
}
</style>
<script>
export default {
    data() {
        return {
            selected: 1,
            options: [
                {value: 1, text: '1 Mes', id: 2},
                {value: 2, text: '2 Meses', id: 3},
                {value: 4, text: '4 Meses', id: 4},
                {value: 8, text: '8 Meses', id: 5},
            ],
            membershipSelection: {
                candidates: 5,
                price: 200,
                validity: 1,
                percentage: {
                    one: '',
                    two: ''
                }
            },
            loading: {
                payment: false
            }
        }
    },
    methods: {
        changeMember() {
            switch (this.selected) {
                case 1:
                    this.membershipSelection.candidates = 5
                    this.membershipSelection.price = 200
                    this.membershipSelection.percentage.one = ''
                    this.membershipSelection.percentage.two = ''
                    this.membershipSelection.validity = 1
                    break
                case 2:
                    this.membershipSelection.candidates = 15
                    this.membershipSelection.price = 500
                    this.membershipSelection.percentage.one = 1
                    this.membershipSelection.percentage.two = 0
                    this.membershipSelection.validity = 3
                    break
                case 4:
                    this.membershipSelection.candidates = 30
                    this.membershipSelection.price = 900
                    this.membershipSelection.percentage.one = 1
                    this.membershipSelection.percentage.two = 1
                    this.membershipSelection.validity = 6
                    break
                case 8:
                    this.membershipSelection.candidates = 60
                    this.membershipSelection.price = 1600
                    this.membershipSelection.percentage.one = 0
                    this.membershipSelection.percentage.two = 4
                    this.membershipSelection.validity = 12
                    break
            }
        },
        sendPayment() {

            let plan = this.options.find((i)=>{
                return i.value === this. selected
            })

            this.$router.push('/payment?plan_id=' + plan.id);
        },
        meses(val) {

            if (val === 1) {
                return `${val} mes`
            } else if (val >= 2 && val < 12) {
                return `${val} meses`
            } else if (val === 12) {
                return `1 año`
            } else if (val >= 13) {

                let a = parseInt(val / 12)
                let m = (val - (12 * a))

                if (m === 0) {
                    return `${a} años`
                } else if (a === 1 && m === 1) {
                    return `${a} año ${m} mes`
                } else if (a === 1 && (m >= 2 && m <= 11)) {
                    return `${a} año ${m} meses`
                } else if (a > 1 && m === 1) {
                    return `${a} años ${m} mes`
                } else if (a > 1 && (m >= 2 && m <= 11)) {
                    return `${a} años ${m} meses`
                }

            }
        }
    },
}
</script>



// WEBPACK FOOTER //
// src/components/#public/member/components/PlanPlata.vue